function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "TXT"
}, React.createElement("path", {
  d: "M0,1.35042756 C0,0.604607012 0.60450369,-6.97822024e-15 1.35034656,-6.97822024e-15 L12.823307,-6.97822024e-15 L19.028133,6.22490406 L19.028133,22.6493894 C19.028133,23.395311 18.4232488,24 17.6777828,24 L1.3503502,24 C0.604572376,24 0,23.3954884 0,22.6495724 L0,1.35042756 Z",
  id: "Rectangle-Copy-3",
  fill: "#8A9B9B"
}), React.createElement("path", {
  d: "M19.0895141,6.32225064 L13.4697357,6.32225064 C13.081971,6.32225064 12.7672634,6.00754305 12.7672634,5.61977835 L12.7672634,0",
  id: "Fill-139-Copy-3",
  fill: "#000000",
  opacity: 0.207823822
}), React.createElement("path", {
  d: "M6.60245524,15.1991816 L6.60245524,18.4143223 L7.46976982,18.4143223 L7.46976982,15.1991816 L8.65196931,15.1991816 L8.65196931,14.4699744 L5.42025575,14.4699744 L5.42025575,15.1991816 L6.60245524,15.1991816 Z M10.0717136,16.3482353 L8.69616368,18.4143223 L9.6684399,18.4143223 L10.5468031,17.049821 L11.4085934,18.4143223 L12.4416368,18.4143223 L11.066087,16.3537596 L12.3311509,14.4699744 L11.3809719,14.4699744 L10.5799488,15.7295141 L9.80654731,14.4699744 L8.80112532,14.4699744 L10.0717136,16.3482353 Z M13.6625064,15.1991816 L13.6625064,18.4143223 L14.529821,18.4143223 L14.529821,15.1991816 L15.7120205,15.1991816 L15.7120205,14.4699744 L12.4803069,14.4699744 L12.4803069,15.1991816 L13.6625064,15.1991816 Z",
  id: "Shape",
  fill: "#FFFFFF"
}));

var SvgTxt = function SvgTxt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 24",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTxt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/txt.ef47f211.svg";
export { ForwardRef as ReactComponent };